import EventBus from "eventing-bus"
import gsap from "gsap"
import { constants } from "../model"

const viewEl = document.querySelector("#loading-view"),
  imageContainer = viewEl.querySelector(".image-container"),
  imagesArr = imageContainer.querySelectorAll("img"),
  numImages = imagesArr.length

let currIdx = Math.floor(Math.random() * numImages)

/**
 * Event handlers
 */
const handleSectionChanged = () => {
  viewEl.classList.remove("show")
}

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)

/**
 * Fn
 */
const init = () => {
  setTimeout(() => {
    viewEl.classList.add("show")
    gsap.set(imagesArr, { alpha: 0 })
    nextImage()
  }, 100)
}

init()

const nextImage = () => {
  currIdx = currIdx === numImages - 1 ? 0 : currIdx + 1
  let nextNum = currIdx + 1 > numImages - 1 ? 0 : currIdx + 1

  // in
  gsap.to(imagesArr[currIdx], { duration: 0.4, alpha: 0, x: 150, delay: 0.4, ease: "circ.in" })
  // out
  gsap.fromTo(imagesArr[nextNum], { alpha: 0, x: -150 }, { duration: 1, alpha: 1, x: 0, delay: 0.8, ease: "circ.out" })
  setTimeout(() => {
    nextImage()
  }, 2000)
}
